import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { normalizePermTitle, permisosModelHasAnyTitle } from '../utils/permisosTree';

const routeToModuleTitles = (pathname) => {
  if (pathname.startsWith('/mod-reportes/')) {
    const tipo = normalizePermTitle(pathname.split('/')[2] || '');
    const reportMap = {
      'ingreso-por-dia': [],
      gastos: [],
      popularidad: ['popularidad de productos'],
      'descuentos-cortesias': ['descuentos y cortesias'],
      cancelaciones: ['cancelaciones'],
      'relacion-ventas': ['relacion de ventas'],
      'ventas-por-hora': ['ventas por hora'],
      'productos-vendidos-por-mesero': ['productos vendidos por mesero'],
    };
    return reportMap[tipo] || [];
  }

  if (pathname.startsWith('/seguridad/') || pathname.startsWith('/configuraciones/')) {
    const seccion = normalizePermTitle(pathname.split('/')[2] || '');
    if (seccion === 'roles') return ['roles'];
    if (seccion === 'usuarios') return ['cuentas', 'usuarios'];
    return [];
  }

  if (pathname.startsWith('/organizaciones/')) {
    const seccion = normalizePermTitle(pathname.split('/')[2] || '');
    if (seccion === 'empresas' || seccion === 'empresa') return ['empresa', 'empresas'];
    if (seccion === 'sucursales' || seccion === 'sucursal') return ['sucursal', 'sucursales'];
    return ['organizacion', 'organizaciones'];
  }

  return [];
};

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
        Cargando...
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const requiredModules = routeToModuleTitles(location.pathname);
  const allowed = permisosModelHasAnyTitle(user?.PermisosModel, requiredModules);
  if (!allowed) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
